// Fire-and-forget error reporter for Reader web app
// All calls are safe to use anywhere — never throws, never blocks

import { API_BASE } from './config.js';
const ERROR_ENDPOINT = API_BASE + '/error-report';

let reported = 0;
const MAX_REPORTS_PER_SESSION = 50;

const NETWORK_PATTERNS = ['Failed to fetch', 'Load failed', 'NetworkError', 'ERR_NETWORK', 'ERR_INTERNET_DISCONNECTED', 'The Internet connection appears to be offline', 'A server with the specified hostname could not be found'];

function isNetworkError(msg) {
  return NETWORK_PATTERNS.some(p => msg.includes(p));
}

export function reportError(message, opts = {}) {
  if (reported >= MAX_REPORTS_PER_SESSION) return;

  const msg = String(message);
  // Cross-origin scripts (e.g. gsi/client) throwing without CORS headers get
  // stripped by the browser to opaque "Script error." with no stack. Zero
  // diagnostic value and floods the DB on iOS Safari (gsi retries 10+ times
  // per second). Drop before counting against the session cap.
  if (msg === 'Script error.' && !opts.stack) return;
  reported++;

  const level = isNetworkError(msg) ? 'network' : (opts.level || 'error');

  const token = localStorage.getItem('easeverse_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  fetch(ERROR_ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      client: 'reader',
      level,
      message: msg.slice(0, 10000),
      stack: opts.stack?.slice(0, 50000) || undefined,
      url: location.href,
      metadata: opts.metadata,
    }),
  }).catch(() => {}); // fire-and-forget
}

export function installGlobalErrorReporter() {
  window.addEventListener('error', (event) => {
    reportError(event.message || String(event.error), {
      stack: event.error instanceof Error ? event.error.stack : undefined,
      metadata: {
        source: 'window.onerror',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    const stack = reason instanceof Error ? reason.stack : undefined;
    reportError(message, {
      stack,
      metadata: { source: 'unhandledrejection' },
    });
  });
}
